import * as React from "react";

const IconChange: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="currentColor"><path fill="currentColor" d="M0,12 L0.239062428,10.8046875 L0.75,8.25 L8.20546889,0.794531107 L9,0 L9.79453111,0.794531107 L11.203125,2.203125 L12,3 L11.2054689,3.79453111 L3.75,11.25 L1.1953125,11.7609372 L0,12 Z M3.19453132,10.2140622 L8.95546889,4.45546889 L7.546875,3.046875 L1.78593743,8.80546904 L1.43437493,10.5656254 L3.19453096,10.2140629 L3.19453132,10.2140622 Z"  transform="translate(0 .5)"/></svg>;
};

export default React.memo(IconChange);
